export default __webpack_public_path__ + "static/im_hero_1024-552a3df9aa2d8081552796a0b4b30281.png";